function Observer(handleFunction) {
    this.handle = handleFunction;
}

export default Observer;
